import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

interface TeamCardProps {
  src: string;
  name: string;
  role: string;
  email: string;
  linkedin: string;
}

const TeamCard: React.FC<TeamCardProps> = ({
  src,
  name,
  role,
  email,
  linkedin,
}) => {
  return (
    <div className="team-container">
      {/* Imagen del miembro */}
      <div className="team-image">
        <img loading="lazy" decoding="async" src={src} alt={name} />
      </div>

      {/* Nombre */}
      <div className="team-name">
        <p>{name}</p>
      </div>

      {/* Cargo */}
      <div className="team-role">
        <p>{role}</p>
      </div>

      {/* Redes sociales */}
      <div className="team-socials">
        {email && (
          <a
            href={`mailto:${email}`}
            rel="noopener noreferrer"
            className="team-social-icon"
            aria-label="Email"
          >
            <FontAwesomeIcon icon={faEnvelope} />
          </a>
        )}
        {linkedin && (
          <a
            href={linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="team-social-icon"
            aria-label="LinkedIn"
          >
            <FontAwesomeIcon icon={faLinkedinIn} />
          </a>
        )}
      </div>
    </div>
  );
};

export default TeamCard;
